<template>
  <div v-if="!chartsReady " class="wait-wrapper">
    <div class="loader-dual-ring" />
  </div>
  <div v-else id="wrapper" class="chart-wrapper">
    <div
      v-for="(row, name) in chartsData"
      :key="row.name"
      class="chart-row"
      :class="[multi-session, (isMultiSession) ? multi-session : '']"
    >
      <div v-for="chart in row" :key="chart.name" class="chart-small">
        <ChartCard
          :id="chart.id"
          :name="name"
          :data="chart.apex"
          :labels="chart.labels"
          :series="chart.series"
          @chart-clicked="chartZoomHandler(chart.name)"
        />
      </div>
    </div>
  </div>

  <!-- <ConfirmModal
    ref="confirmModal"
    :messageHeader="confirmMessageHeader"
    :message="confirmMessage"
    :buttonClass="'button-delete'"
    :buttonText="buttonText"
    @confirmed="confirmFunction"
  /> -->
</template>

<script>
import ChartCard from '@/components/ValidationPage/ChartCard.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

export default {
  name: 'ValidateSessionCharts',
  components: {
    ChartCard,
    ConfirmModal,
  },
  emits: ['stop-validate', 'refresh'],
  data() {
    return {
      chartsReady: false,
      chartsData: {},
      isMultiSession: false,
    };
  },
  computed: {
    hasResults() {
      return this.internalSession && this.internalSession.results && Object.keys(this.internalSession.results).length > 0;
    },
    type() {
      return this.internalSession && this.internalSession.params ? this.internalSession.params.type : null;
    },
  },
  beforeUnmount() {
    this.clearData();
    this.stopInterval();
    this.stopEC2StatusInterval();
  },
  async created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
    if (this.$route.query.session_id) {
      // parse int or Array
      const session_ids = JSON.parse(decodeURI(this.$route.query.session_id));
      await this.GetChartsData(session_ids);
    } else {
      this.$router.push({ path: '/validator' });
    }
  },
  methods: {
    async GetChartsData(ids) {
      const data = await this.getValidateGraphs(ids);

      let N = 0;
      for (const k in data) {
        N = Math.max(data[k].length, N);
      }

      if (N > 1) {
        this.isMultiSession = true;
      } else {
        this.isMultiSession = false;
      }

      this.chartsData = data;
      this.chartsReady = true;
    },
    async refresh() {
      await this.GetChartsData();
    },
    chartModalClosed() {
      clearInterval(this.interval);
    },
    chartZoomHandler(name) {
      alert(name);
    },
    async fetchCharts() {
      // Get Training Charts from BE
      const params = {
        project_id: this.projectID,
      };
      if (this.trainerExperiment == null) {
        params.session_id = this.trainerSession.id;
        params.trainer_id = this.trainerSession.trainer_id;
      } else {
        params.trainer_id = this.trainerExperiment.id;
      }

      const resp = await this.dataConnect.getCharts(params)
        .catch((error) => {
          console.log('Failed to launch analytics:', error);
        });
      if (!resp || resp.error || !resp.result) {
        return {};
      }
      return resp.result;
    },
    handleModalClosed() {
      this.chartsReady = false;
    },

    //= ===============================================================================================

    async getDataset(id) {
      const params = {
        dataset_id: id,
        get_annotation_sets: true,
      };
      const resp = await this.dataConnect.getDatasetById(params)
        .catch((error) => {
          // TODO: handle error
          console.log(error);
        });
      if (resp.error) {
        return null;
      } else {
        return resp.result;
      }
    },
    clearData() {
      this.selectedSessionAvailableFiles = [];
      this.dataset = null;
      clearInterval(this.interval);
      this.interval = null;
      clearInterval(this.logsInterval);
      this.logsInterval = null;
      this.refreshTimeout = false;
    },
    getName(id) {
      const result = this.dataset?.annotation_sets.find((e) => e.id === id);
      return result?.name || 'Unknown';
    },
    getEpoch(session) {
      if (session.docker_task) {
        return session.docker_task.count;
      }
      return 0;
    },
    getTotalEpochs(session) {
      let params = {};
      if (session && session.params) {
        params = session.params;
      }
      if (params.epochs) {
        return params.epochs;
      }
      return null;
    },
    getStatus(session) {
      if (session?.docker_task) {
        return session.docker_task.status;
      }
      return "Failed to start docker task";
    },

    getCount(session) {
      if (session?.docker_task) {
        return session.docker_task.count;
      }
      return "Failed to get docker task";
    },
    getTotal(session) {
      if (session?.docker_task) {
        return session.docker_task.total;
      }
      return null;
    },
    formatTime(str) {
      return `${new Date(str).toLocaleTimeString('default', {
        year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
      })}`;
    },
    openConfirmStopValidateSessionModal() {
      this.confirmMessage = `Are you sure you want to stop this validate session? You will lose all current progress.`;
      this.confirmMessageHeader = 'Stop Validate Session';
      this.toDelete = this.internalSession;
      this.buttonText = 'Stop';
      this.$refs.confirmModal.showModal();
      this.confirmFunction = () => {
        this.handleStopValidateSessions([this.internalSession.id]);
      };
    },
    async handleStopValidateSessions(ids) {
      await this.dataConnect.terminateValidateSessions({
        session_ids: ids,
      })
        .then(() => {
          this.updateValidatorEC2InstanceStatus();
        })
        .catch((error) => {
          console.log(error);
        });

      this.toDelete = null;
    },
    async updateValidatorEC2InstanceStatus() {
      await this.dataConnect.validateUpdateEC2({
        dataset_ids: [this.internalSession.dataset_id],
      })
        .catch((e) => console.log(e));
    },
    stopInterval() {
      clearInterval(this.interval);
      this.interval = null;
    },
    startInterval(session_id) {
      this.interval = setInterval(async () => {
        this.internalSession = await this.getValidateSession(parseInt(session_id));
      }, 30000);
    },
    startEC2StatusInterval() {
      this.ec2Interval = setInterval(this.updateValidatorEC2InstanceStatus, 60000);
    },
    stopEC2StatusInterval() {
      clearInterval(this.ec2Interval);
      this.ec2Interval = null;
    },
    async getValidateGraphs(ids) {
      const resp = await this.dataConnect.getValidateGraphs({
        session_ids: ids,
      });
      if (resp.error) {
        return null;
      } else {
        return resp.result;
      }
    },
    async getValidateSession(id) {
      const resp = await this.dataConnect.getValidateSession({
        validate_session_id: id,
      });
      if (resp.error) {
        return null;
      } else {
        return resp.result;
      }
    },
    handleRefreshClicked() {
      this.refreshTimeout = true;
      setTimeout(() => {
        this.refreshTimeout = false;
      }, 5000);
      this.internalSession = this.getValidateSession(this.internalSession.id);
    },

  },
};

</script>

<style lang="scss" scoped>

.chart-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height:95vh;
  flex-direction: row;
  flex-wrap: wrap;

  padding: 4px;
  background-color: rgb(101, 107, 109);

  overflow-y: auto ;

}

.chart-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin:4px;
  align-content: start;
}
.multi-session {
  width: 99%;
}

.chart-small{
  border-radius: 8px;
  //width: 700px;
  // height: 300px;
  background-color: rgb(247, 246, 246);
  flex-grow: 0;

  margin: 4px;
}

.wait-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgb(101, 107, 109);

}

.loader-dual-ring {
  position: absolute;
  display: inline-block;
  width: 80px;
  height: 80px;
}

.loader-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  @include themify() {
    border: 6px solid themed('color-primary');
    border-color: themed('color-primary') transparent themed('color-primary') transparent;
  }
  animation: loader-dual-ring 1.2s linear infinite;
}
@keyframes loader-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

// .sessions {
//   display: flex;
//   flex-direction: column;
//   width: 50%;
//   padding: 16px;
//   @media (max-width: $breakpoint-sm) {
//     width: 100%;
//   }
//   @media (max-width: $breakpoint-md) {
//     width: 100%;
//   }

//   ul {
//     list-style-type: none;
//   }
//   .session-header {
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;

//    .icon-container {
//     display: flex;
//     align-items: center;
//       @include themify() {
//         color: themed('body-text-color-secondary');
//       }
//       .icon + .icon {
//         margin-left: 10px;
//       }
//       .icon:hover {
//         @include themify() {
//           color: themed('icon-color-primary');
//         }
//       }
//     }
//   }

//   h3 {
//     margin: 0;
//     margin-bottom: 10px;
//     font-size: 1rem;
//     text-align: left;
//     @include themify() {
//       color: themed('body-text-color-secondary');
//     }
//   }

//   &__body-row {
//     display: flex;
//     flex: 1 1 auto;
//     margin-top: 5px;
//     align-items: center;
//   }
// }

// ._disabled {
//   @include themify() {
//     background: themed('color-disabled-200') !important;
//     color: white;
//     cursor: not-allowed !important;
//     pointer-events: none;
//     border: 1px solid transparent !important;
//   }
// }

// .validate-sessions {
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
//   list-style: none;
//   padding: 2px 4px;
//   margin: 2px -4px;

//   &__list-item2 {
//     display: flex;
//     flex-direction: row;
//     position: relative;
//     background: rgb(231, 224, 224);
//     padding: 8px;
//     border-radius: 4px;
//     gap: 16px;
//     align-items: center;
//     @include themify() {
//       background: themed('color-white-700');
//     }
//     height: 100%;
//     border: 1px solid grey;

//     .session-col {
//       display: flex;
//       flex-direction: column;
//       width: fit-content;

//       label, span {
//         text-align: center;
//         overflow-wrap: anywhere;
//         pointer-events: none;
//       }
//       label {
//         font-weight: 600;
//         font-size: 0.625rem;
//         letter-spacing: 0.05em;
//         white-space: nowrap;
//         @include themify() {
//           color: themed('body-text-color-secondary');
//         }
//       }
//       span {
//         font-weight: 700;
//         font-size: 0.75rem;
//         @include themify() {
//           color: themed('color-primary');
//         }
//       }
//     }

//     .status-col {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       text-align: center;

//       .date {
//         margin-top: 5px;
//         font-weight: 600;
//         font-size: 0.625rem;
//         letter-spacing: 0.05em;
//         white-space: nowrap;
//         @include themify() {
//           color: themed('body-text-color-secondary');
//         }
//       }
//     }

//     .name-col {
//       display: flex;
//       flex-direction: column;

//       &__main {
//         display: flex;
//         flex-direction: row;
//           justify-content: space-around;
//         .item {
//           display: flex;
//           flex-direction: column;
//           width: 50%;
//         }

//       }

//       label, span {
//         text-align: center;
//         overflow-wrap: anywhere;
//         pointer-events: none;
//       }
//       label {
//         font-weight: 600;
//         font-size: 0.625rem;
//         letter-spacing: 0.05em;
//         white-space: nowrap;
//         @include themify() {
//           color: themed('body-text-color-secondary');
//         }
//       }
//       span {
//         font-weight: 700;
//         font-size: 0.75rem;
//         padding-left: 10px;
//         padding-right: 10px;
//         overflow: hidden;
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         @include themify() {
//           color: themed('color-primary');
//         }
//       }
//     }
//   }
// }
// ._selected {
//   @include themify() {
//     border: solid 1px themed('color-primary');
//     background: rgba(themed('color-primary'), 0.2);
//   }
// }

// .validate-sessions__list-item2 div[val-epoch] {
//   flex: 0 1 100px;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }

// .validate-sessions__list-item2 div[val-status] {
//   min-width: 130px !important;
//   flex: 0 1 auto;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }
// .validate-sessions__list-item2 div[val-name] {
//   flex: 1 1 120px;
//   width: 120px;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }

// .status-tag {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100px;
//   min-width: 100px;
//   border-radius: 18px;
//   padding: 4px 6px;
//   line-height: 1;
//   font-size: 0.625rem;
//   font-weight: 700;
//   white-space: nowrap;
//   border: 2px solid;
//   box-shadow: 0px 0px 1px rgb(0 0 0 / 25%), 0px 1px 4px rgb(0 0 0 / 25%);
//   @include themify() {
//     color: themed('color-black');
//   }

//   &._complete {
//     @include themify() {
//       color: themed('color-status-complete');
//       background: themed('color-status-complete-background');
//     }
//   }
//   &._running {
//     @include themify() {
//       color: themed('color-status-running');
//       background: themed('color-status-running-background');
//     }
//   }
//   &._error {
//     @include themify() {
//       color: themed('color-status-error');
//       background: themed('color-status-error-background');
//     }
//   }
//   &._warning {
//     @include themify() {
//       color: themed('color-status-warning');
//       background: themed('color-status-warning-background');
//     }
//   }

//   .running-icon {
//     color: inherit;
//     width: 4px;
//     height: 4px;
//     border: solid 4px;
//     border-radius: 4px;
//     margin-right: 4px;
//   }

//   .status-icon {
//     color: inherit;
//     margin-right: 4px;
//   }
// }

// hr.vr {
//   display: flex;
//   width: 1px;
//   height: 24px;
//   margin: 0;
// }

// a {
//   text-decoration:none;
// }
// a + button {
//   margin-left: 10px;
// }

// .stats-container {
//   margin: 10px;
//   width: 100%;
// }

// .flex-col {
//   display: flex;
//   flex-direction: row;
//   padding: 0 20px 0 10px;

//   div + div {
//     margin-left: 20px;
//   }

//   @media (max-width: $breakpoint-sm) {
//     flex-direction: column;
//     div + div {
//       margin-left: 0;
//       margin-top: 20px;
//     }
//   }
//   @media (max-width: $breakpoint-md) {
//     flex-direction: column;
//     div + div {
//       margin-left: 0;
//       margin-top: 20px;
//     }
//   }
// }

// .col-40 {
//   width: 40%;
// }

// .col-50 {
//   width: 50%;
// }

// .col-60 {
//   width: 60%;
// }

// @media (max-width: $breakpoint-sm) {
//   .col-40 {
//   width: 100%;
//   }
//   .col-50 {
//   width: 100%;
//   }
//   .col-60 {
//   width: 100%;
//   }
// }

// @media (max-width: $breakpoint-md) {
//   .col-40 {
//   width: 100%;
//   }
//   .col-50 {
//   width: 100%;
//   }
//   .col-60 {
//   width: 100%;
//   }
// }
// .empty-state {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   position: relative;
//   width: 100%;
//   height: 100%;
// }
</style>
